import { Access } from '../../enums';
import { Permission } from '../permission';

const BASE_DATA_KEY = 'base-data';
export const BASE_DATA = {
  DOCTORS: {
    READ: new Permission({
      key: `${BASE_DATA_KEY}:doctors:${Access.READ}`,
      description: 'Ärzte – Leserecht',
    }),

    WRITE: new Permission({
      key: `${BASE_DATA_KEY}:doctors:${Access.WRITE}`,
      description: 'Ärzte - Schreibrecht',
    }),
  },

  INSURANCE: {
    READ: new Permission({
      key: `${BASE_DATA_KEY}:insurance:${Access.READ}`,
      description: 'Krankenkassen – Leserecht',
    }),

    WRITE: new Permission({
      key: `${BASE_DATA_KEY}:insurance:${Access.WRITE}`,
      description: 'Krankenkassen - Schreibrecht',
    }),
  },

  WELFARE_OFFICE: {
    READ: new Permission({
      key: `${BASE_DATA_KEY}:welfare-office:${Access.READ}`,
      description: 'Sozialämter – Leserecht',
    }),

    WRITE: new Permission({
      key: `${BASE_DATA_KEY}:welfare-office:${Access.WRITE}`,
      description: 'Sozialämter - Schreibrecht',
    }),
  },

  SUPERVISOR: {
    READ: new Permission({
      key: `${BASE_DATA_KEY}:supervisor:${Access.READ}`,
      description: 'Betreuer – Leserecht',
    }),

    WRITE: new Permission({
      key: `${BASE_DATA_KEY}:supervisor:${Access.WRITE}`,
      description: 'Betreuer - Schreibrecht',
    }),
  },
};
